<app-header></app-header>
<div class="container mt-2 pt-5">
    <div class="row align-items-center">
    
    	<div class="col-md-6 pr-0 order-md-1">
            <!-- <img src="https://omni-marketing-assets.s3.amazonaws.com/Partner-meetings.png" class="img-fluid">             -->
            <img src="../../assets/img/Partner-meetings.png" class="img-fluid">            
        </div>
    	
    	<div class="col-md-6 feature-txt">
            <h2 class="h2">Become a Partner</h2>
            <p class="text-justify">OMNI is the world's first upskilling platform for enterprise AI-RPA skills. It is a value-added aggregator of top RPA, OCR, and other AI platforms in one place. Join OMNIConnect today to disrupt the AI-RPA skilling landscape.</p>
        </div>
        
        
    </div>
</div>
<div class="bg-grey pt-0">
    <div class="container py-5">
      <div class="row">
        <div class="col-md-7 text-justify pr-md-5">
          <h1 class="h2 text-left mb-4">Why OMNIConnect</h1>
          <p>Organizations are looking to build citizen developers to accelerate their digital transformation journey, without having to invest in expensive automation interventions with large SI vendors. They are also looking for an opportunity to evaluate different platforms suitable for their organization without additional expenditure.</p>
          <p>As we take steps to disrupt and change the AI-RPA upskilling landscape completely, we are looking for like-minded partners.</p>
          <p>We invite you to be a part of our Partner Connect Program, OMNIConnect. The OMNIConnect program is built on 3 pillars:</p>
          <ul class="ml-3 list-item">
              <li class="mb-2"><strong>Innovation:</strong> Getting the first mover advantage in a rapid growth area.</li>
              <li class="mb-2"><strong>Revenue focused:</strong> We help you get more license revenue, both by referring net new clients for license sale and driving more revenue from your current clients.</li>
              <li class="mb-2"><strong>Vision:</strong> We are here to help organizations build critical internal digital skills, by enhancing their internal talent development efforts.</li>
          </ul>
          
          <video width="100%" height="auto" controls="">
                    <source src="https://omni-marketing-assets.s3.amazonaws.com/omni-partner-video.mp4" type="video/mp4">
                    <!--<source src="movie.ogg" type="video/ogg">-->
                  Your browser does not support the video tag.
                  </video>
          
        </div>
        
        
      
        <div class="col-md-5 form-bg bg-white p-5 mt-2 mb-5">
              <p class="h3 text-center pb-3">Partner With Us</p>
            <form [formGroup]="partnerForm">
                <div class="row">                                
                    <div class="col-md-12 mb-4">
                        <input class="search form-control pl-3" type="text" placeholder="Name*" formControlName="name" name="partner name">
                        <span class="alert small mt-2" *ngIf="(partnerFormControl.name.touched || submit) && partnerFormControl.name.errors?.required"> Please enter your name</span>
                        <span class="alert small mt-2" *ngIf="partnerFormControl.name.touched && partnerFormControl.name.errors?.pattern"> Please enter a valid name</span>        
                    </div>
                    <div class="col-md-12 mb-4">
                        <input class="search form-control pl-3" type="text" placeholder="Email*" formControlName="email" name="email">
                        <span class="alert small mt-2" *ngIf="(partnerFormControl.email.touched || submit) && partnerFormControl.email.errors?.required"> Please enter your mail id</span>
                        <span class="alert small mt-2" *ngIf="partnerFormControl.email.touched && partnerFormControl.email.errors?.email"> Please enter a valid email address</span>        
                    </div>
                    <div class="col-md-12 mb-4">
                        <input class="search form-control pl-3" type="number" placeholder="Contact Number" formControlName="contact" name="contact">
                        <span class="alert small mt-2" *ngIf="(partnerFormControl.contact.touched || submit) && partnerFormControl.contact.errors?.pattern"> Please enter a valid contact number</span>        
                    </div>
                    <div class="col-md-12 mb-4">
                        <input class="search form-control pl-3" type="text" placeholder="Company Name" formControlName="companyName" name="company name">
                    </div>
                    <div class="col-md-12 mb-4">
                        <input class="search form-control pl-3" type="text" placeholder="Job Title" formControlName="jobTitle" name="job title">
                    </div>
                    <div class="col-md-12 mb-4">
                       <textarea class="form-control search" rows="2" placeholder="Enter Message" formControlName="msg" name="message"></textarea>
                    </div>
                </div>                           
                 <p class="small mt-2">By sharing your details, you agree with OMNI's <a href="https://app.omnicoe.com/tnc" target="_blank" class="active">terms of use</a> and <a href="https://app.omnicoe.com/tnc" target="_blank" class="active">privacy policy</a>.</p>
                <div class="pt-4">
                    <a class="bg-button btn btn-primary bd-highlight text-white" (click)="becomePartner()">Submit</a>
                    
                </div>
            </form>
        </div>
        
      </div>
    </div>
</div>

<section id="first-feature" class="container py-5">
  <div class="row justify-content-center">
      <div class="col-md-12 text-center ">
          <h2 class="h2">Benefits of joining OMNIConnect</h2>
      </div>
  </div>	
  
  <div class="row align-items-center my-5">
      <div class="col-md-12 feature-txt">
          <ul class="custom-bullet">
              <li><p>Higher visibility for your platform: You get listed alongside your peers, and your customers can evaluate how you are better than your competition.</li>
              <li>Additional license sale at zero investment: OMNI can help you win over fence sitters and sell your licenses without any additional investment. You can also list your solution on our POC Library.</li>
              <li>Clear path to profitability: We show you a clear path towards profitability. We help you get more license revenue, both by referring net new clients for license sale and driving more revenue from your current clients.</li>
              <!--<li>Access to the world's first aggregator of AI and RPA platforms.</li>
              <li>1000+ downloadable POCs [pre-uploaded use-cases and POC's.</li>
              <li>Access to a special 50% discount valid till September 30.</li>-->
          </ul>
      </div>
      <div class="col-md-12 pt-5">
          <h2 class="h5">If you have questions about the OMNI Partner Connect program, <a target="_blank" href="https://omni-marketing-assets.s3.amazonaws.com/OMNI+Partner+Flyer+2.pdf">download OMNIConnect overview</a> or mail us at <a target="_blank" href="mailto: info@omnicoe.com">info@omnicoe.com</a></h2>
      </div>
  </div>
</section>

<!--Main Layout-->

<section class="container-fluid py-5 bg-img">
  <div class="container">
      <div class="row justify-content-center">
          <div class="col-md-12 text-center ">
              <h2 class="h2 text-white">OMNI Partners</h2>
              
          </div>
      </div>	
      
      
      <div class=" poc">
          <div class="marque">
              <ul>
                  <li><img src="../../assets/img/aai.jpg"></li>
                  <li><img src="../../assets/img/abbyy.jpg"></li>
                  <li><img src="../../assets/img/adobe.jpg"></li>
                  <li><img src="../../assets/img/alexa.jpg"></li>
                  <li><img src="../../assets/img/aws.jpg"></li>
                  <li><img src="../../assets/img/azurebot.jpg"></li>
                  <li><img src="../../assets/img/dialogflow.jpg"></li>
                  <li><img src="../../assets/img/google.jpg"></li>
                  <li><img src="../../assets/img/ms.jpg"></li>
                  <li><img src="../../assets/img/net.jpg"></li>
                  <li><img src="../../assets/img/oracle.jpg"></li>
                  <li><img src="../../assets/img/sfdc.jpg"></li>
                  <li><img src="../../assets/img/tally.jpg"></li>
                  <li><img src="../../assets/img/uip.jpg"></li>                 
              </ul>
          </div>
      </div>
      </div>
</section>

<app-footer></app-footer>

<div class="modal fade" id="thanks-modal" tabindex="-1" role="dialog" aria-labelledby="thanks-modal" aria-hidden="true">
    <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
            <div class="modal-body">
                <h5 class="modal-title h3">Thank You for submitting the form</h5>
                <p>Our team will get in touch with you for the next steps!</p>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary border-button" data-dismiss="modal">Ok</button>
            </div>
        </div>
    </div>
</div>